import { render, staticRenderFns } from "./OudeHavenkranen.vue?vue&type=template&id=5ddca15c&"
import script from "./OudeHavenkranen.vue?vue&type=script&lang=ts&"
export * from "./OudeHavenkranen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports